export default function bootstrap(options) {
  const { components } = options;

  let graphQlFragments = '';

  components.forEach((component) => {
    graphQlFragments += `${component.graphQlSchema}\n`;
  });

  return {
    graphQlFragments: graphQlFragments.trim(),
  };
}
